import { Outlet } from 'react-router-dom'
import { BtnWebPalermo } from '../../../componentes/btnWebPalermo'
import { Marcas } from '../../../componentes/marcas'
import { Social } from '../../../componentes/social'
import { BtnSweetPalermo } from '../../../componentes/btnSweetPalermo'

export function Layout1() {
    return (
        <>
            <main className="bg-white">
                <Outlet />
            </main>
            <aside>
                <Marcas />
                <div className="wrapper">
                    <div className="flex items-center justify-center my-4">
                        <BtnSweetPalermo />
                    </div>
                    <Social />
                </div>
            </aside>
        </>
    )
}
